/*
 * @Author: your name
 * @Date: 2020-05-25 09:47:23
 * @LastEditTime: 2020-06-01 17:38:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /FE-DSTemplate/src/components/CouponWithStatus/index.js
 */ 
import React from 'react';
import PropTypes from 'prop-types';
import './index.scss'
import _ from 'lodash';
import {isLogged, trackClick} from '@/utils/util';
import api from '@/services/api';
import { Toast } from 'antd-mobile';
class CouponMovie extends React.Component {
  static propTypes = {
    couponBg: PropTypes.string,
    notYetGetBg: PropTypes.string,
    alreadyGotBg: PropTypes.string,
    gotStampBg: PropTypes.string,
    status: PropTypes.number,
    promotionId: PropTypes.string
  }

  getCoupon = async()=>{
    const {promotionId, status, refreshPromotionStatus} = this.props;
    if(status === 2) {return Toast.info('今天已经领券，快去使用吧，明天也能领券呦~');}
    const token = await isLogged() 
    if(!token){
      window.crgt.router.openLogin().then((res) => {
        if (res && res.code === 0) {
         return refreshPromotionStatus && refreshPromotionStatus()
        }
      });
      return;
    }
    trackClick('c_click_common_78', {promotionId})
    const res = await api.movieDailyCouponService.grantMovieDailyCoupon({promotionId})
    refreshPromotionStatus()
    if(res.code !== 0) return;
    Toast.info('领取成功~')
  }

  render() {
    const { couponBg, notYetGetBg, alreadyGotBg, gotStampBg, status } = this.props;
    const rightSideBg = status === 2 ? alreadyGotBg : notYetGetBg;
    return (
      <>
        <div className="movie-coupon" style={{ backgroundImage: `url(${couponBg})` }} onClick={this.getCoupon}>
          <div className="movie-coupon-right" style={{ backgroundImage: `url(${rightSideBg})` }}></div>
          {status === 2 && <div className="movie-coupon-stamp" style={{ backgroundImage: `url(${gotStampBg})` }}  />}
        </div>
      </>
    );
  }
}

export default CouponMovie;

